document.addEventListener("DOMContentLoaded", function () {
  // 等高处理函数
  function equalHeightByIndex() {
    const wrappers = document.querySelectorAll(".compar-item-wrapper");
    const groupMap = {};

    wrappers.forEach((item) => {
      const idx = item.getAttribute("index");
      if (!groupMap[idx]) {
        groupMap[idx] = [];
      }
      groupMap[idx].push(item);
      // 重置高度
      item.style.height = "auto";
    });

    Object.values(groupMap).forEach((group) => {
      let maxH = 0;
      group.forEach((el) => {
        const h = el.offsetHeight;
        if (h > maxH) maxH = h;
      });
      group.forEach((el) => {
        el.style.height = `${maxH}px`;
      });
    });
  }


  equalHeightByIndex();

  // 窗口resize防抖
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalHeightByIndex, 150);
  });

  // 图片加载完成后，重新计算高度【重点修复】
  const imgs = document.querySelectorAll('.compar-item-pro-img');
  imgs.forEach(img => {
    if (img.complete) {
      equalHeightByIndex();
    } else {
      img.addEventListener('load', equalHeightByIndex);
    }
  })
});
